// 非ログインページのパス
export const WITHOUT_AUTH_PATHS = {
  REGISTRATION: {
    INDEX: '/registration',
    COMPLETED: '/registration/completed',
  },
  REGISTRATION_TRIAL: {
    INDEX: '/registration/trial',
    COMPLETED: '/registration/trial/completed',
  },
  INVITATION_CONFIRMATION: {
    SHOW: '/invitation_confirmation',
  },
  CHANGE_EMAIL_CONFIRMATION: {
    SHOW: '/change_mail_confirmation',
  },
  EXPIRE_TOKENS: {
    INDEX: '/expire_token',
  },
}

// 管理者ページのパス
export const WITH_AUTH_ADMIN_PATHS = {
  EMPLOYEES: {
    UPDATE_REQUESTS: {
      INDEX: '/employees/update_requests',
      SHOW: '/employees/update_requests/:id',
    },
  },
  DIRECT_REQUEST: {
    INDEX: '/direct_request',
    REQUEST: '/direct_request/request',
  },
  DOCUMENTS: {
    INDEX: '/documents',
    SHOW: '/documents/:id',
    DOCUMENT_ID: {
      EMPLOYEES: {
        INDEX: '/documents/:documentId/employees',
      },
    },
    EMPLOYEES: {
      SHOW: '/documents/employees/:id',
      CONTRACTS: {
        SHOW: '/documents/employees/:id/contracts/:contractRequestId',
        CREATE: '/documents/employees/:id/contracts/create',
      },
    },
  },
  EGOV_PROCEDURES: {
    INDEX: '/egov_procedures',
    SHOW: '/egov_procedures/:id',
  },
  SETTINGS: {
    INDEX: '/settings',
    EGOV: {
      SHOW: '/settings/egov',
      EDIT: '/settings/egov/edit',
      ACCOUNT: {
        SHOW: '/settings/account',
      },
    },
    GROUPS: {
      IMPORT: '/settings/groups/import',
      IMPORT_UPDATE: '/settings/groups/import_update',
    },
    CUSTOM_MAILS: {
      INDEX: '/settings/custom_mails',
      EDIT: '/settings/custom_mails/:emailType',
    },
    ALERT_CUSTOM: {
      SHOW: '/settings/alert_custom',
      CREATE: '/settings/alert_custom/create',
      EDIT: '/settings/alert_custom/edit/:id',
    },
    PAT: {
      INDEX: '/settings/pat',
    },
  },
  PROCEDURE_NEW: {
    INDEX: '/procedure_new',
  },
  PROCEDURE_STATUSES: {
    CHOOSE_PROCEDURE: '/procedure_statuses/choose_procedures',
    PROCEDURE_STATUS_ID: {
      ATTACHMENTS: '/procedure_statuses/:id/attachments',
      EGOV: {
        PREPARE: '/procedure_statuses/:id/egov/prepare',
      },
      R510_IMPORT_PAYMENTS: '/procedure_statuses/:id/r510_import_payments',
    },
  },
  ALERTS: {
    INDEX: '/alerts',
  },
  CHANGE_OFFICE: {
    INDEX: '/change_office',
    PERSONNEL_HISTORY: '/change_office/:id/personnel_history',
    DETAIL: '/change_office/detail',
    FLOW: '/change_office/flow/:id',
    UPDATE: '/change_office/update/:id',
  },
  HEALTHCARE_START: {
    INDEX: '/healthcare_start',
  },
  SYSTEM_ANNOUNCES: {
    LIST: '/system_announces',
    SHOW: '/system_announces/:id',
  },
  CHILDCARE_LEAVE: {
    INDEX: '/childcare_leave',
  },
  START_CHILDCARE: {
    INDEX: '/start_childcare',
    REQUEST: '/start_childcare/request',
    FLOW: '/start_childcare/flow/:id',
    CONFIRM: '/start_childcare/confirm/:id',
  },
  EXTEND_CHILDCARE: {
    INDEX: '/extend_childcare',
    REQUEST: '/extend_childcare/request',
    FLOW: '/extend_childcare/flow/:id',
    CONFIRM: '/extend_childcare/confirm/:id',
  },
  FINISH_CHILDCARE: {
    INDEX: '/finish_childcare',
    REQUEST: '/finish_childcare/request',
    FLOW: '/finish_childcare/flow/:id',
    CONFIRM: '/finish_childcare/confirm/:id',
  },
  ADDITIONAL_CHILDCARE_LEAVE_ALLOWANCE: {
    INDEX: '/additional_childcare_leave_allowance',
    CREATE: '/additional_childcare_leave_allowance/create',
    FLOW: '/additional_childcare_leave_allowance/flow/:id',
  },
  PARENTAL_LEAVE: {
    INDEX: '/parental_leave',
    REQUEST: '/parental_leave/request',
    FLOW: '/parental_leave/flow/:id',
    CONFIRM: '/parental_leave/confirm/:id',
  },
  PARENTAL_LEAVE_SUPPORT_ALLOWANCE: {
    INDEX: '/parental_leave_support_allowance',
    REQUEST: '/parental_leave_support_allowance/request',
    FLOW: '/parental_leave_support_allowance/flow/:id',
    CONFIRM: '/parental_leave_support_allowance/confirm/:id',
  },
  HEALTH_INSURANCE_QUALIFICATION_CONFIRMATION: {
    INDEX: '/health_insurance_qualification_confirmation',
    CREATE: '/health_insurance_qualification_confirmation/create',
    FLOW: '/health_insurance_qualification_confirmation/flow/:id',
  },
} as const

export const WITH_AUTH_TM_PATHS = {
  LOGOUT: '/tm/logout',
} as const

export const WITH_AUTH_PATHS = {
  DASHBOARD: '/dashboard',
  LOGOUT: '/logout',
} as const

// MEMO: 権限管理実装後は従業員ページがマイページ(従業員も管理者もアクセスできる)になるはず
// マイページのパス
export const MYPAGE_PATHS = {
  DOCUMENTS: {
    INDEX: '/mypage/documents',
  },
  PROCEDURE_NEW: {
    INDEX: '/mypage/procedure_new',
  },
  PROCEDURES: {
    CHANGE_DEPENDENTS: {
      INDEX: '/mypage/change_dependents',
    },
    ADD_DEPENDENTS: {
      CHOOSE_NEW_OR_EXISTS: '/mypage/add_dependents/choose_new_or_exists',
      CHOOSE_EXIST_DEPENDENTS: '/mypage/add_dependents/choose_exist_dependents',
      EMPLOYEE_INPUT: '/mypage/add_dependents/employee_input/:id?',
      EMPLOYEE_INPUT_DEPENDENTS: '/mypage/add_dependents/employee_input_dependents/:id',
    },
    REMOVE_DEPENDENTS: {
      EMPLOYEE_INPUT: '/mypage/remove_dependents/employee_input/:id?',
      CHOOSE_DEPENDENTS: '/mypage/remove_dependents/choose_dependents',
    },
    CHILDCARE_LEAVE: {
      INDEX: '/mypage/childcare_leave',
    },
    START_CHILDCARE: {
      FLOW: '/mypage/start_childcare/flow/:id',
    },
    EXTEND_CHILDCARE: {
      FLOW: '/mypage/extend_childcare/flow/:id',
    },
    FINISH_CHILDCARE: {
      FLOW: '/mypage/finish_childcare/flow/:id',
    },
    PARENTAL_LEAVE: {
      INDEX: '/mypage/parental_leave',
      FLOW: '/mypage/parental_leave/flow/:id',
    },
    PARENTAL_LEAVE_SUPPORT_ALLOWANCE: {
      INDEX: '/mypage/parental_leave_support_allowance',
      FLOW: '/mypage/parental_leave_support_allowance/flow/:id',
    },
  },
} as const

type GenerateDynamicPath = (
  path: string,
  patterns: {
    pattern: string
    replacement: string
  }[]
) => string

export const generateDynamicPath: GenerateDynamicPath = (path, patterns) => {
  return patterns.reduce((prev, current) => prev.replace(`:${current.pattern}`, current.replacement), path)
}
